// What the client decided about each item on an itemized change order.
//
// The backend bills every item the client has not declined (an item added
// after they chose is billed until they refuse it — see _item_is_billed), so
// "Approved" here means "authorized for production" once the client has
// answered or paid, and "Awaiting client" before that.

const ANSWERED_STATUSES = new Set([
  "client_approved", "invoice_sent", "paid", "cleared_for_production",
  "in_production", "completed", "fully_paid",
]);

export function clientHasAnswered(co) {
  return !!(co?.client_selection_at || co?.deposit_paid || ANSWERED_STATUSES.has(co?.status));
}

export function itemDecision(li, co) {
  if (li?.client_decision === "declined") return "declined";
  if (li?.client_decision === "approved" || clientHasAnswered(co)) return "approved";
  return "awaiting";
}

export const DECISION_LABEL = {
  approved: "Approved",
  declined: "Declined",
  awaiting: "Awaiting client",
};

export const DECISION_TONE = {
  approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  declined: "bg-orange-50 text-orange-800 border-orange-200",
  awaiting: "bg-slate-50 text-slate-500 border-slate-200",
};

// "4 of 5 items approved" once the client has answered; null before, or for
// an order that is not itemized.
export function decisionSummary(co) {
  const lines = co?.line_items || [];
  if (!co?.itemized || lines.length === 0 || !clientHasAnswered(co)) return null;
  const approved = lines.filter(li => itemDecision(li, co) === "approved").length;
  return `${approved} of ${lines.length} item${lines.length !== 1 ? "s" : ""} approved`;
}
